import { render, staticRenderFns } from "./SuppDetails.vue?vue&type=template&id=5568d604&"
import script from "./SuppDetails.vue?vue&type=script&lang=js&"
export * from "./SuppDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports